import * as React from "react";
import { connect } from "react-redux";
import { IconNames } from '@blueprintjs/icons';
import { Popover, Button, Menu, MenuItem, Position } from "@blueprintjs/core";

import { bindActionCreators, Dispatch } from "redux";
import * as configActions from "../../actions/configActions";
import * as editActions from "../../actions/editActions";
import initialState from "../../reducers/initialState";
import JsonEditor from "./JsonEditor";
import styled from "styled-components";

const EditorWrapper = styled.div`
	display: grid;
	grid-template:
    ' top ' auto
    ' main ' 1fr;
    grid-gap: 15px;
`;

class ConfigEditor extends React.PureComponent<
	{config: object, actions: typeof configActions & typeof editActions}> {

	constructor(props) {
		super(props);
	}

	private onSave = (data) => {
		this.props.actions.loadConfigSuccess(data, data.key);
		this.props.actions.editChangesIncrement();
	}

	public render() {

		const menu = (
			<Menu>
				<MenuItem text="Site Config" />
				<MenuItem text="Site Layout" />
				<MenuItem text="Entire Store" />
			</Menu>
		);

		return (
			<EditorWrapper>
				<Popover content={menu} position={Position.RIGHT_TOP} usePortal={false}>
					<Button icon={IconNames.CHEVRON_DOWN}>Site Config</Button>
				</Popover>
				<JsonEditor data={this.props.config} onSave={this.onSave} />
			</EditorWrapper>
		);
	}
}

function mapStateToProps(state: typeof initialState = initialState, ownProps: any) {
	return {
		config: state.config
	};
}

function mapDispatchToProps(dispatch: Dispatch<typeof initialState>) {
	return {
		actions: bindActionCreators({...configActions, ...editActions}, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfigEditor);



// WEBPACK FOOTER //
// ./src/core/components/editor/ConfigEditor.tsx